/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Update_ReloadInputs */

const vi_pwa_update_reload = /** @type {(inputs: Pwa_Update_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lại`)
};

/**

* @param {Pwa_Update_ReloadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pwa_update_reload = /** @type {((inputs?: Pwa_Update_ReloadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Update_ReloadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pwa_update_reload(inputs)
});